module.exports = "/matchcenter-staging/assets/images/eurosport_2.7fbc6267a6c895824b533fea3e306572.png";